<template>
  <div class="customCode">
    <label>{{ label }}:</label>
    <a
      v-if="codeBase"
      href="#"
      class="customCode__searchBtn"
      @click.prevent="showSearchBar"
      >
      <icon name="search" />
      Search
    </a>
    <ul>
      <li
        v-if="codeBase"
        v-for="(codeItem, key) in codeBase"
        :key="key"
        class="customCode__item"
        >
        <a
          href="#"
          @click.prevent="editCode(key)"
          >
          {{ codeItem.name }}.{{ type }}
        </a>
        <a
          href="#"
          class="customCode__renameCode"
          v-b-tooltip.hover
          title="rename"
          @click.prevent="update(key)"
          >
          <icon name="pencil" />
        </a>
        <a
          href="#"
          class="customCode__removeCode"
          v-b-tooltip.hover
          title="remove"
          @click.prevent="remove(key)"
          >
          <icon name="remove" />
        </a>
      </li>
    </ul>
    <b-button
      variant="primary"
      size="sm"
      @click="create"
      class="customCode__addBtn"
      >
      <icon name="plus" />
      Create
    </b-button>
    <hr v-if="!isLast">
  </div>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: [
    'label',
    'type',
    'codeBase',
    'isLast'
  ],
  methods: {
    create () {
      eventBus.$emit('showCustomCodeModal', this.type)
    },
    editCode (key) {
      this.$store.commit('editCustomCode', {
        key,
        insert: true
      })
    },
    update (key) {
      eventBus.$emit('showCustomCodeUpdateModal', key, this.type)
    },
    remove (key) {
      let confirm = window.confirm('Are you sure?')
      if (!confirm) return

      db.customCode.delete(key, this.type, (err) => {
        if (err) this.$store.commit('addError', err.message)
      })
    },
    showSearchBar () {
      eventBus.$emit('showSearchBar', this.type)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.customCode {
  position: relative;
  &__addBtn {
    svg {
      vertical-align: -3px;
    }
  }
  &__item {
    position: relative;
    border-bottom: 1px solid $borderColor1;
    padding-right: 40px;
  }
  &__removeCode {
    position: absolute;
    right: 0;
    top: 2px;
  }
  &__renameCode {
    position: absolute;
    right: 18px;
    top: 2px;
  }
  &__searchBtn {
    position: absolute;
    right: 0;
    top: 0px;
    svg {
      vertical-align: -1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Toolbar/CustomCode/CodeType.vue